const blogData = [
    {
      id: 1,
      title: "First Blog Post",
      content: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...",
      author: "Lorem Ipsum",
      date: "2024-03-15",
    },
    {
      id: 2,
      title: "Test data",
      content: "There is no one who loves pain itself, who seeks after it and wants to have it, simply because it is pain...",
      author: "Lorem Ipsum",
      date: "2024-03-14",
    },
  ];
  
  export default blogData;
  